import { useMemo, useState } from "react";
import { newsItems, columnsForNews } from "../../../mocks/communityData";

export default function NewsFeed() {
  const [active, setActive] = useState("全部");
  const [visible, setVisible] = useState(4);

  const filtered = useMemo(
    () => (active === "全部" ? newsItems : newsItems.filter((n) => n.column === active)),
    [active]
  );

  const shown = filtered.slice(0, visible);

  return (
    <section id="news" className="scroll-mt-20 bg-background-100/70 py-14">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-primary-500">
              <i className="ri-news-line" /> Fresh
            </span>
            <h2 className="mt-2 font-display text-3xl text-foreground-900 md:text-4xl">最新瓜料</h2>
            <p className="mt-2 text-foreground-600">每天更新的新鲜话题与深度盘点，点开就能聊。</p>
          </div>
        </div>

        {/* 分类筛选 */}
        <div className="mt-6 flex flex-wrap gap-2">
          {columnsForNews.map((c) => (
            <button
              key={c}
              onClick={() => {
                setActive(c);
                setVisible(4);
              }}
              className={`rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition ${
                active === c
                  ? "bg-primary-500 text-white"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-500"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* 列表 */}
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {shown.map((n) => (
            <article
              key={n.id}
              className="flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition hover:border-accent-200 hover:bg-background-100 sm:flex-row"
            >
              <div className="relative h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-44 lg:w-52">
                <img src={n.img} alt={n.title} className="h-full w-full object-cover transition duration-500 hover:scale-105" />
                {n.hot && (
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-white">
                    <i className="ri-fire-fill" /> 热门
                  </span>
                )}
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="font-semibold text-accent-600">{n.column}</span>
                  <span className="text-background-300">|</span>
                  <span>{n.date}</span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line" /> {n.reads}
                  </span>
                </div>
                <h3 className="mt-2 line-clamp-2 text-base font-bold leading-snug text-foreground-900 transition hover:text-primary-500">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{n.desc}</p>
                <a
                  href="#faq"
                  className="mt-auto inline-flex items-center gap-1 pt-3 text-sm font-semibold text-primary-500 hover:text-primary-600 whitespace-nowrap"
                >
                  加入讨论 <i className="ri-arrow-right-line" />
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* 更多按钮 */}
        {visible < filtered.length && (
          <div className="mt-8 flex justify-center">
            <button
              onClick={() => setVisible(visible + 4)}
              className="rounded-full border border-background-300 bg-background-50 px-8 py-3 text-sm font-bold text-foreground-700 transition hover:border-primary-300 hover:text-primary-500 whitespace-nowrap"
            >
              查看更多瓜料
            </button>
          </div>
        )}
      </div>
    </section>
  );
}